import { Div } from '../../../base/components/native/div'
import { DButton } from '../../shared/d-button'
import { DInput } from '../../shared/d-input'

export const Redemm = () => {

    const base = Div()
    const amount = DInput('استفاده از امتیاز', { type: 'number' })
    const submit = DButton('ثبت')
    base.append(amount, submit)

    submit.el.onclick = () => {
        base.emit('submit', amount.getValue())
        amount.setValue('')
    }
    
    submit.cssClass({
        marginRight: '20px',
    })
    base.cssClass({
        margin: '40px 0 30px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    })

    return base
}